module.exports = __webpack_public_path__ + "img/logo.cf639da1.png";